import './styles/TimelineNavigation.scss';

import { CSSProperties, useMemo } from 'react';

import { cn } from '../../helpers/classBuilders';
import { useClassHelper } from '../../hooks/useClassHelper';
import { Tooltip } from '../Tooltip/Tooltip';
import { Paragraph } from '../Typography';

const componentName = 'c-TimelineNavigation';

interface Props {
  loading?: boolean;
  disabledPages?: string[];
  [key: string]: any;
}

export function TimelineNavigation({
  c: mainClass,
  variant = 'default',
  loading,
  disabledPages = [],
  ...props
}: Props) {
  const c = useClassHelper(componentName);

  const filteredPages = props.pages.filter(
    (page: any) => page !== props.preludePageKey,
  );

  const style = useMemo(() => {
    if (props.preludePage) {
      return {
        '--total-progress':
          (100 / (filteredPages.length - 1)) * (props.currentPageIndex - 1),
      };
    }

    return {
      '--total-progress':
        (100 / (filteredPages.length - 1)) * props.currentPageIndex,
    };
  }, [props.preludePage, props.currentPageIndex]) as CSSProperties;

  if (props.preludePage) {
    return null;
  }

  return (
    <div className={`${componentName} ${c('--' + variant)}`} style={style}>
      {filteredPages.map((page: any, index: number) => {
        const active = page === props.currentPage;
        const isDisabled = disabledPages.includes(page);

        return (
          <a
            key={page}
            href={'#'}
            aria-disabled={loading || isDisabled}
            className={cn(
              c(
                '__entry',
                active ? '__entry--active' : '',
                props.currentPageIndex > index ? '__entry--visited' : '',
                loading ? '__entry--loading' : '',
              ),
              isDisabled && 'cursor-not-allowed',
            )}
            onClick={event => {
              event.preventDefault();

              if (loading || isDisabled) {
                return;
              }

              props.goTo(page);
            }}
          >
            {isDisabled ? (
              <Tooltip
                align="top"
                wrapperClassName="absolute! bottom-1/2 left-1/2 mb-2.5 -translate-x-1/2"
                trigger={
                  <span className="block w-22 text-center text-xs whitespace-normal text-gray-500! cursor-not-allowed">
                    {page}
                  </span>
                }
                content={
                  <Paragraph className="w-96 text-white!" align="center">
                    Save your watch activation settings before moving on to the
                    next steps
                  </Paragraph>
                }
              />
            ) : (
              <span
                className={cn(c('__title'), 'text-gray-500!', {
                  'text-gray-800! hover:text-gray-900! font-bold': active,
                })}
              >
                {page}
              </span>
            )}
          </a>
        );
      })}
    </div>
  );
}
